import { render } from "./BasicView.vue?vue&type=template&id=44bfaede"
import script from "./BasicView.vue?vue&type=script&lang=js"
export * from "./BasicView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__